// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1-IKj","title":"ClientInsurance_title__26y50","itemText":"ClientInsurance_itemText__2s0GT"};